import { Text } from "@chakra-ui/react";

import { DetailData } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";

interface IProps {
  rentalPrice: DetailData["rentalPrice"];
  offerTypeId: DetailData["offerTypeId"];
  isDetailPrice?: boolean;
}

const RentalPrice: React.FC<IProps> = ({
  isDetailPrice,
  rentalPrice,
  offerTypeId,
}) => {
  const getCurrency = () => (rentalPrice?.currency === "CZK" ? "Kč" : "");

  const getPrice = () => {
    switch (offerTypeId) {
      case "sale": {
        return `${rentalPrice?.value.toLocaleString("cs-CZ", {
          // maximumFractionDigits: options.decimalPlaces,
          currency: "czk",
        })} ${getCurrency()}`;
      }
      case "rent":
      case "coliving": {
        return `${rentalPrice?.value.toLocaleString("cs-CZ", {
          // maximumFractionDigits: options.decimalPlaces,
          currency: "czk",
        })} ${getCurrency()}${isDetailPrice ? "/měsíc" : ""}`;
      }
      default: {
        return "";
      }
    }
  };

  return (
    <>
      {rentalPrice && rentalPrice.value !== 1 ? (
        <>
          <Text as="span" color="black" fontSize="inherit">
            {getPrice()}
          </Text>
        </>
      ) : (
        <>Info o ceně na dotaz</>
      )}
    </>
  );
};

export default RentalPrice;
